import CreateChannel from './CreateChannel';

export default CreateChannel;
export { CreateChannel };
